import { ofType, combineEpics } from 'redux-observable';
import { mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { getGroupDeviceDataOnTabChange } from 'middleware/data/actions';
import { NO_OP } from 'middleware/utils';
import {
  getGroupListSuccess,
  getGroupListError,
} from 'store/groupList/actions';
import { GET_GROUP_LIST } from './actions';

const getGroupListEpic = (action$, state$, { groupRequest }) => action$.pipe(
  ofType(GET_GROUP_LIST),
  mergeMap(() => groupRequest.getGroupList$().pipe(
    mergeMap((response) => {
      const { data } = response;
      return of(
        data && data.length > 0
          ? getGroupDeviceDataOnTabChange(data[0].id)
          : NO_OP,
        getGroupListSuccess(data),
      );
    }),
    catchError(error => of(getGroupListError(error))),
  )),
  catchError(error => of(getGroupListError(error))),
);

export default combineEpics(getGroupListEpic);
